import { createContext, useContext, useState } from 'react';
import { esTranslations } from './esTranslations';
import { enTranslations } from './enTranslations';

type Lang = 'es' | 'en';

interface LangCtx {
  lang: Lang;
  setLang: (l: Lang) => void;
  t: (key: string, fallback?: string) => string;
}

const LangContext = createContext<LangCtx>({ lang: 'es', setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const [lang, setLangState] = useState<Lang>(() => {
    return (localStorage.getItem('spartech_lang') as Lang) ?? 'es';
  });

  const setLang = (l: Lang) => {
    localStorage.setItem('spartech_lang', l);
    setLangState(l);
  };

  const t = (key: string, fallback?: string): string => {
    const map = lang === 'es' ? esTranslations : enTranslations;
    return map[key] ?? fallback ?? key;
  };

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export function useLang() { return useContext(LangContext); }
